import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Youtube, Instagram } from 'lucide-react';
export function HomeNavigationContact() {
  return <div className="hidden lg:flex items-center gap-4 flex-shrink-0" data-id="element-523">
      <Link to="/contact" className="px-6 py-2.5 bg-[#dc2626] text-white text-sm font-bold rounded-lg hover:bg-red-700 transition-colors border-2 border-[#a3d977]/30" data-id="element-524">
        Contact Us
      </Link>

      {/* Social Media Icons */}
      <div className="flex items-center gap-2 pl-3 ml-3 border-l border-gray-300" data-id="element-525">
        <a href="https://www.facebook.com/NwBlackBeltAcademy/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-6 h-6 text-[#1e3a8a] hover:text-[#0f1f3d] transition-colors" aria-label="Facebook" data-id="element-526">
          <Facebook className="w-5 h-5" data-id="element-527" />
        </a>
        <a href="https://www.youtube.com/channel/UCVz3NW22j-95JDLAvEWXrHw" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-6 h-6 text-[#1e3a8a] hover:text-[#dc2626] transition-colors" aria-label="YouTube" data-id="element-528">
          <Youtube className="w-5 h-5" data-id="element-529" />
        </a>
        <a href="https://www.instagram.com/nw_black_belt_academy/?hl=en" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-6 h-6 text-[#1e3a8a] hover:text-[#0f1f3d] transition-colors" aria-label="Instagram" data-id="element-530">
          <Instagram className="w-5 h-5" data-id="element-531" />
        </a>
      </div>
    </div>;
}